import React, { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa6";
import { useUserContext } from "../../context/UserContext";

export default function SelectScenario() {
  const {
    isTesting,
    scenarios,
    scenario,
    setScenario,
    subscenario,
    setSubscenario,
    flushType,
    setFlushType,
  } = useUserContext();
  const [expandScenario, setExpandScenario] = useState(false);
  const [expandSubScenario, setExpandSubScenario] = useState(false);
  const [expandType, setExpandType] = useState(false);

  useEffect(() => {
    let sc = scenario || Object.keys(scenarios)[0];
    setScenario(sc);
    setSubscenario(scenarios[sc][0]);
  }, []);

  useEffect(() => {
    if (isTesting) {
      setExpandScenario(false);
      setExpandSubScenario(false);
    }
  }, [isTesting]);

  function changeScenario(scenario) {
    setScenario(scenario);
    setSubscenario(scenarios[scenario][0] || []);
    setExpandScenario(false);
  }
  function changeSubScenario(subScenario) {
    setSubscenario(subScenario);
    setExpandSubScenario(false);
  }
  function changeType(type) {
    setFlushType(type);
    setExpandType(false);
  }

  return (
    <div className="flex gap-3">
      <div id="scenarioDropdown" className="relative">
        <button
          disabled={isTesting}
          onClick={() => setExpandScenario(!expandScenario)}
          className="flex gap-2 justify-between items-center py-2 px-4 w-full font-bold text-white bg-indigo-500 rounded hover:bg-indigo-700 disabled:bg-gray-500"
        >
          <span className="capitalize">{scenario}</span>
          <FaChevronDown />
        </button>
        <ul
          className="absolute p-2 min-w-full bg-gray-100 rounded divide-y divide-black cursor-pointer"
          style={{ display: expandScenario ? "block" : "none" }}
        >
          {Object.keys(scenarios).map((sc, i) => (
            <li
              key={i}
              className="py-1 hover:bg-gray-200"
              onClick={() => changeScenario(sc)}
            >
              {sc}
            </li>
          ))}
        </ul>
      </div>

      <div
        id="subScenarioDropdown"
        className={`relative ${!scenarios[scenario].length && "hidden"}`}
      >
        <button
          disabled={isTesting}
          onClick={() => setExpandSubScenario(!expandSubScenario)}
          className="flex gap-2 justify-between items-center py-2 px-4 w-full font-bold text-white bg-indigo-500 rounded hover:bg-indigo-700 disabled:bg-gray-500"
        >
          <span className="capitalize">{subscenario}</span>
          <FaChevronDown />
        </button>
        <ul
          className="absolute p-2 min-w-full bg-gray-100 rounded divide-y divide-black cursor-pointer"
          style={{ display: expandSubScenario ? "block" : "none" }}
        >
          {scenarios[scenario].map((subScenario, i) => (
            <li
              key={i}
              className="py-1 capitalize hover:bg-gray-200"
              onClick={() => changeSubScenario(subScenario)}
            >
              {subScenario}
            </li>
          ))}
        </ul>
      </div>

      <div
        id="typeDropdown"
        className={`relative ${scenario !== "check_request" && "hidden"}`}
      >
        <button
          disabled={isTesting}
          onClick={() => setExpandType(!expandType)}
          className="flex gap-2 justify-between items-center py-2 px-4 w-full font-bold text-white bg-indigo-500 rounded hover:bg-indigo-700 disabled:bg-gray-500"
        >
          <span className="capitalize">{flushType}</span>
          <FaChevronDown />
        </button>
        <ul
          className="absolute p-2 min-w-full bg-gray-100 rounded divide-y divide-black cursor-pointer"
          style={{ display: expandType ? "block" : "none" }}
        >
          {["check", "change", "replace"].map((t, i) => (
            <li
              key={i}
              className="py-1 capitalize hover:bg-gray-200"
              onClick={() => changeType(t)}
            >
              {t}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
